import { createStyles, makeStyles, Theme, pressedLinkShadow } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  fixedMenu: {
    display: 'none',
  },
  fixedMenuActive: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    background: theme.color.greys[0],
    justifyContent: 'space-evenly',
    display: 'flex',
    boxShadow: `0px 8px 8px ${pressedLinkShadow}`,
    zIndex: 999,
    '& $headerCell': {
      width: '50%',
    },
  },
  fixedMenuBottom: {
    padding: '8px 0',
    background: theme.color.greys[0],
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    '& $chooseButtonCell': {
      '&:first-child': {
        borderRight: `1px solid ${theme.color.greys[15]}`,
      },
    },
  },
  chooseButtonCell: {
    width: '100%',
    marginTop: 8,
    marginBottom: 8,
    padding: '0 16px',
  },
  chooseButton: {
    boxShadow: 'none',
    width: '100%',
  },
  productLink: {
    marginBottom: 32,
  },
  buttonRight: {
    borderLeft: `1px solid ${theme.color.greys[15]}`,
  },
  rightElementWithBorder: {
    marginLeft: -16,
    paddingLeft: 16,
    borderLeft: `1px solid ${theme.color.greys[15]}`,
    height: '100%',
  },
  rowWithBackground: {
    background: theme.color.greys[10],
  },
  tableRoot: {
    background: theme.color.greys[0],
    marginBottom: 90,
  },
  tableHead: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  headerCell: {
    padding: 16,
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    marginBottom: 8,
  },
  noteCell: {
    padding: '16px 16px 8px 16px',
    textAlign: 'center',
  },
  itemCell: {
    padding: '0 16px 16px 16px',
    border: 0,
    verticalAlign: 'top',
  },
  productItemLabel: {
    marginBottom: 8,
  },
  productItemText: {
    '& ul': {
      listStyleType: 'square',
      paddingLeft: 28,
      margin: 0,
      '& li': {
        marginBottom: 8,
        '&:last-child': {
          marginBottom: 0,
        },
      }
    },
  },
  additionalActionRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    borderTop: `1px solid ${theme.color.greys[15]}`,
  },
  additionalActionCell: {
    padding: '16px 16px 24px 16px',
  },
  additionalActionBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    '& > div': {
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
  additionalActionBoxWithBorder: {
    borderLeft: `1px solid ${theme.color.greys[15]}`,
    paddingLeft: 16,
    marginLeft: -16,
  },
  link: {
    alignSelf: 'flex-start',
  },
  currency: {
    whiteSpace: 'nowrap',
  },
}), { name: 'IkeOrIkzeMobile' });
